module.exports = __webpack_public_path__ + "img/cloud-sun.18bc80f.jpg";